import React from 'react'; // eslint-disable-line

/* Components */
import { TipsterRoute } from '../CustomRoute/TipsterRoute';
import { StoreTypesReversed } from '../PaymentGateway/interfaces/store_types';

/* Interfaces */
import { ITipsterRoute } from './DynamicRoutes';
import { ShopContainerConnected } from '../Shops/ShopContainer';

const tipsterLinks: ITipsterRoute[] = [
  {
    slug: 'MomiazosbyWerever',
    tipster_id: 'c0uqntvftk4kk2ahueqg',
    tracker_code: 'sxs6ixq',
  },
  {
    slug: 'MomiazosWerever',
    tipster_id: 'c0uqntvftk4kk2ahueqg',
    tracker_code: 'sxs6ixq',
  },
];

export const createCustomTipsterLinks = () =>
  tipsterLinks.map(
    (route) =>
      route.slug.length && (
        <TipsterRoute
          component={() => (
            <ShopContainerConnected storeType={StoreTypesReversed.Premium} />
          )}
          tipsterSlug={route.slug}
          path={`/premium/${route.slug}`}
          key={route.slug}
          tipsterID={route.tipster_id}
          adjustTracker={route.tracker_code}
        />
      ),
  );
